import React from 'react';

export const IconVisibility = ({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99998 8.09999C6.58331 8.09999 7.07914 7.89583 7.48748 7.48749C7.89581 7.07916 8.09998 6.58333 8.09998 5.99999C8.09998 5.41666 7.89581 4.92083 7.48748 4.51249C7.07914 4.10416 6.58331 3.89999 5.99998 3.89999C5.41664 3.89999 4.92081 4.10416 4.51248 4.51249C4.10414 4.92083 3.89998 5.41666 3.89998 5.99999C3.89998 6.58333 4.10414 7.07916 4.51248 7.48749C4.92081 7.89583 5.41664 8.09999 5.99998 8.09999ZM5.99998 7.19999C5.66664 7.19999 5.38331 7.08333 5.14998 6.84999C4.91664 6.61666 4.79998 6.33333 4.79998 5.99999C4.79998 5.66666 4.91664 5.38333 5.14998 5.14999C5.38331 4.91666 5.66664 4.79999 5.99998 4.79999C6.33331 4.79999 6.61664 4.91666 6.84998 5.14999C7.08331 5.38333 7.19998 5.66666 7.19998 5.99999C7.19998 6.33333 7.08331 6.61666 6.84998 6.84999C6.61664 7.08333 6.33331 7.19999 5.99998 7.19999ZM5.99998 9.59999C4.81168 9.59999 3.72918 9.27291 2.7525 8.61874C1.77582 7.96458 1.05831 7.09166 0.599976 5.99999C1.05831 4.90833 1.77582 4.03541 2.7525 3.38124C3.72918 2.72708 4.81168 2.39999 5.99998 2.39999C7.18828 2.39999 8.27077 2.72708 9.24745 3.38124C10.2241 4.03541 10.9416 4.90833 11.4 5.99999C10.9416 7.09166 10.2241 7.96458 9.24745 8.61874C8.27077 9.27291 7.18828 9.59999 5.99998 9.59999Z"
        fill="currentColor"
      />
    </svg>
  );
};
